<template>
    <div class="alert-failed-check-payment-method">
        <modal height="auto" width="50px" name="failed-check-payment-method-loading-modal" :clickToClose="false">
            <div style="height: 50px; width: 50px;">
                <div class="loader">
                    <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                    </svg>
                </div>
            </div>
        </modal>
        <modal height="auto" width="550px" name="failed-check-payment-method-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col" style="padding: 20px;">
                <div class="header">
                    ⚠️Oops, your card verification has failed
                </div>
                <div class="body" style="color: rgba(0, 0, 0, 0.9);">
                    <div>Your card was not authorized by Stripe.</div>
                    <div>Please try again with a different card or contact our support for help.</div>
                </div>
                <div class="footer flex justify-content-between space-x-2">
                    <div></div>
                    <div>
                        <form method="POST" action="/start-new-subscription">
                            <input
                                type="hidden"
                                id="try_again_after_failed_check_pm"
                                name="try_again_after_failed_check_pm"
                                value="true"/>
                            <a class="btn gray mr-2" href="mailto:support@ppcshield.io">CONTACT SUPPORT</a>
                            <button class="btn btn-primary" style="color: white" type="submit">TRY AGAIN</button>
                        </form>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        data(){
            return {

            }
        },
        methods: {
            temporarilyHide(){
                this.$modal.hide('failed-check-payment-method-modal');
            },
            showAlert(){
                this.$modal.show('failed-check-payment-method-modal');
            },
            showLoadingAlert(){
                this.$modal.show('failed-check-payment-method-loading-modal');
            },
            hideLoading(){
                this.$modal.hide('failed-check-payment-method-loading-modal');
            },
            checkPaymentMethod() {
                axios.post('/notification/checkPaymentMethod')
                    .then(info => {
                        if(info.data === 'ok'){
                            this.hideLoading();
                        }
                        else if(info.data === 'error'){
                            this.hideLoading();
                            this.showAlert();
                            axios.post('/notification/checkPaymentMethodRemoveSubscription')
                                .catch(err => console.log('err', err));
                        }
                        else setTimeout(() => this.checkPaymentMethod(), 1000);
                    })
                    .catch(err => console.log('err', err));
            }
        },
        mounted() {
            this.showLoadingAlert();
            this.checkPaymentMethod();
        }
    }
</script>
